export const FILTER_CHOICE = 'choice';
export const FILTER_RANGE = 'range';